import { colors } from 'design-system';
import VectorIcon from './VectorIcon';
import IconProps from './IconProps';

const LightIcon = ({ width = 30, height = 24 }: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M7.663 15H12.336H7.663ZM10 1V2V1ZM16.364 3.636L15.657 4.343L16.364 3.636ZM19
       10H18H19ZM2 10H1H2ZM4.343 4.343L3.636 3.636L4.343 4.343ZM6.464 13.536C5.76487
        12.8367 5.2888 11.9458 5.09598 10.9759C4.90316 10.006 5.00225 9.00076 5.38073
         8.08721C5.75921 7.17366 6.40007 6.39284 7.22229 5.84349C8.0445 5.29414 9.01115
          5.00093 10 5.00093C10.9889 5.00093 11.9555 5.29414 12.7777 5.84349C13.5999
           6.39284 14.2408 7.17366 14.6193 8.08721C14.9977 9.00076 15.0968 10.006
            14.904 10.9759C14.7112 11.9458 14.2351 12.8367 13.536 13.536L12.988
             14.083C12.6747 14.3963 12.4262 14.7683 12.2567 15.1777C12.0872 15.5871
              11.9999 16.0259 12 16.469V17C12 17.5304 11.7893 18.0391 11.4142
               18.4142C11.0391 18.7893 10.5304 19 10 19C9.46957 19 8.96086 18.7893
                8.58579 18.4142C8.21071 18.0391 8 17.5304 8 17V16.469C8 15.574
                 7.644 14.715 7.012 14.083L6.464 13.536Z"
      stroke={colors.bright_turquoise}
    />
  </VectorIcon>
);

export default LightIcon;
